import { TypeEntity } from ".";
import { getCachedTypeEntity } from "./TypeEntityCache";

export class BaseEntity {
  protected _dataTypeName: string = "";
  protected _id: number;
  protected _character_id: number;
  props: any;

  constructor(id: number, props: any, character_id?: number) {
    this._id = id;
    this.props = props;
    this._character_id = character_id ? character_id : 1;
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props = this.props;
    var entity: Excel.EntityCellValue = {
      type: Excel.CellValueType.entity,
      text: props["name"] || "",
      properties: {},
      provider: {
        description: "Powered by EVE Online",
        logoSourceAddress: "https://excelprodstc.blob.core.windows.net/$web/app/assets/logo-filled.png",
        logoTargetAddress: "https://www.eveonline.com/",
      },
    };
    // Properties
    if (entity.properties) {
      // - Data Type
      if (this._dataTypeName !== "") {
        entity.properties["data_type"] = {
          type: Excel.CellValueType.string,
          basicValue: this._dataTypeName,
        };
      }
      // - Id
      entity.properties["id"] = {
        type: Excel.CellValueType.formattedNumber,
        basicValue: this._id,
        numberFormat: "##0",
      };
      // - Autogenerated properties
      Object.keys(props).forEach((prop) => {
        if (entity.properties) {
          switch (typeof props[prop]) {
            case "string":
              if (prop === "description") {
                entity.properties[prop] = {
                  type: Excel.CellValueType.string,
                  basicValue: props[prop].replace(/<\/?[^>]+(>|$)/g, ""),
                };
              } else {
                entity.properties[prop] = {
                  type: Excel.CellValueType.string,
                  basicValue: props[prop],
                };
              }
              break;
            case "boolean":
              entity.properties[prop] = {
                type: Excel.CellValueType.boolean,
                basicValue: props[prop],
              };
              break;
            case "number":
              if (prop === "id" || prop.endsWith("_id") || prop.endsWith("ID") || prop === "issued_by") {
                entity.properties[prop] = {
                  type: Excel.CellValueType.formattedNumber,
                  basicValue: props[prop],
                  numberFormat: "##0",
                };
              } else {
                entity.properties[prop] = {
                  type: Excel.CellValueType.double,
                  basicValue: props[prop],
                };
              }
              break;
            default:
              if (props[prop] instanceof Date) {
                entity.properties[prop] = {
                  type: Excel.CellValueType.string,
                  basicValue: props[prop].toString(),
                };
              }
          }
        }
      });
      // Replace properties that are id's with their corresponding entity
      const properties = Object.keys(entity.properties);
      //var groupEntity: GroupEntity | null = null;
      var typeEntity: TypeEntity | null = null;
      if (entity.properties["published"] == undefined) {
        for (let i = 0; i < properties.length; i++) {
          const prop = properties[i];
          switch (prop) {
            // - Group
            // TODO: Replacing the groupID property in the Type entity with a Group entity will throw the add-in into an infinite loop since the Group entity has a list of types
            // An alternative would be to replace the groupID property with a Group entity that does not include the types in the group
            // case "groupID":
            //   groupEntity = await getCachedGroupEntity(entity.properties[prop].basicValue as number);
            //   if (groupEntity !== null) {
            //     entity.properties["group"] = await groupEntity.toJson();
            //     delete entity.properties[prop];
            //   }
            //   break;
            // - Type
            case "type_id":
            case "item_type_id":
              typeEntity = await getCachedTypeEntity(entity.properties[prop].basicValue as number);
              if (typeEntity !== null) {
                entity.properties["type"] = await typeEntity.toJson();
                delete entity.properties[prop];
              }
              break;
          }
        }
      }
    }
    return entity;
  }
}

export function isEntityOfType(entity: any, type: string): boolean {
  return (
    entity &&
    entity instanceof Object &&
    entity.type === Excel.CellValueType.entity &&
    entity.properties &&
    entity.properties.data_type &&
    entity.properties.data_type.basicValue === type
  );
}
